
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";

interface InviteErrorViewProps {
  error: string;
}

export const InviteErrorView = ({ error }: InviteErrorViewProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-1 items-center justify-center p-4">
      <Card className="w-full max-w-md border-red-200 shadow-lg">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-2">
            <AlertTriangle className="h-12 w-12 text-destructive" />
          </div>
          <CardTitle className="text-destructive text-xl sm:text-2xl">
            {t('groupInvite.inviteError')}
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center">
          <p>{error}</p>
        </CardContent>
        <CardFooter className="flex justify-center">
          <Button 
            onClick={() => navigate('/')} 
            size="mobile"
            rounded="lg"
            variant="gradient"
            className="w-full sm:w-auto"
          >
            {t('groupInvite.goHome')}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};
